import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import HeroSection from "./components/HeroSection";
import TrustBar from "./components/TrustBar";
import CoreOutcomes from "./components/CoreOutcomes";
import ServicesSection from "./components/ServicesSection";
import IndustriesSection from "./components/IndustriesSection";
import ProcessSection from "./components/ProcessSection";

export default function Home() {
  return (
    <main className="font-inter">
      <Navbar />
      <HeroSection />
      <TrustBar />
      <CoreOutcomes />
      <ServicesSection />
      <IndustriesSection />
      <ProcessSection />
      <Footer />
    </main>
  );
}